module.exports = __webpack_public_path__ + "img/hospice-of-west-alabama-logo.fb321d72.jpg";